//# sourceMappingURL=project.mjs.map
/// <reference types="./project.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $duration from "../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $output from "../../interfaces/schemas/outline/output.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $uuid from "../../tiamat/crypto/uuid.mjs";
import * as $list_ from "../../tiamat/gleam/list_.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import * as $user_id from "../data/auth/user_id.mjs";
import * as $status from "../data/status.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, toList, CustomType as $CustomType, isEqual } from "../gleam.mjs";

export class Metadata extends $CustomType {
  constructor(contain_narrative, attachments, integrations, outline) {
    super();
    this.contain_narrative = contain_narrative;
    this.attachments = attachments;
    this.integrations = integrations;
    this.outline = outline;
  }
}
export const Metadata$Metadata = (contain_narrative, attachments, integrations, outline) =>
  new Metadata(contain_narrative, attachments, integrations, outline);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$contain_narrative = (value) =>
  value.contain_narrative;
export const Metadata$Metadata$0 = (value) => value.contain_narrative;
export const Metadata$Metadata$attachments = (value) => value.attachments;
export const Metadata$Metadata$1 = (value) => value.attachments;
export const Metadata$Metadata$integrations = (value) => value.integrations;
export const Metadata$Metadata$2 = (value) => value.integrations;
export const Metadata$Metadata$outline = (value) => value.outline;
export const Metadata$Metadata$3 = (value) => value.outline;

export class V1 extends $CustomType {}
export const Version$V1 = () => new V1();
export const Version$isV1 = (value) => value instanceof V1;

export class V2 extends $CustomType {}
export const Version$V2 = () => new V2();
export const Version$isV2 = (value) => value instanceof V2;

export class Attachment extends $CustomType {
  constructor(name, content_type) {
    super();
    this.name = name;
    this.content_type = content_type;
  }
}
export const Attachment$Attachment = (name, content_type) =>
  new Attachment(name, content_type);
export const Attachment$isAttachment = (value) => value instanceof Attachment;
export const Attachment$Attachment$name = (value) => value.name;
export const Attachment$Attachment$0 = (value) => value.name;
export const Attachment$Attachment$content_type = (value) => value.content_type;
export const Attachment$Attachment$1 = (value) => value.content_type;

export class Salesforce extends $CustomType {
  constructor(opportunity_id) {
    super();
    this.opportunity_id = opportunity_id;
  }
}
export const Integration$Salesforce = (opportunity_id) =>
  new Salesforce(opportunity_id);
export const Integration$isSalesforce = (value) => value instanceof Salesforce;
export const Integration$Salesforce$opportunity_id = (value) =>
  value.opportunity_id;
export const Integration$Salesforce$0 = (value) => value.opportunity_id;

export class Project extends $CustomType {
  constructor(id, name, owners, org_id, deadline, client, collaborators, metadata, created_at, status, version) {
    super();
    this.id = id;
    this.name = name;
    this.owners = owners;
    this.org_id = org_id;
    this.deadline = deadline;
    this.client = client;
    this.collaborators = collaborators;
    this.metadata = metadata;
    this.created_at = created_at;
    this.status = status;
    this.version = version;
  }
}
export const Project$Project = (id, name, owners, org_id, deadline, client, collaborators, metadata, created_at, status, version) =>
  new Project(id,
  name,
  owners,
  org_id,
  deadline,
  client,
  collaborators,
  metadata,
  created_at,
  status,
  version);
export const Project$isProject = (value) => value instanceof Project;
export const Project$Project$id = (value) => value.id;
export const Project$Project$0 = (value) => value.id;
export const Project$Project$name = (value) => value.name;
export const Project$Project$1 = (value) => value.name;
export const Project$Project$owners = (value) => value.owners;
export const Project$Project$2 = (value) => value.owners;
export const Project$Project$org_id = (value) => value.org_id;
export const Project$Project$3 = (value) => value.org_id;
export const Project$Project$deadline = (value) => value.deadline;
export const Project$Project$4 = (value) => value.deadline;
export const Project$Project$client = (value) => value.client;
export const Project$Project$5 = (value) => value.client;
export const Project$Project$collaborators = (value) => value.collaborators;
export const Project$Project$6 = (value) => value.collaborators;
export const Project$Project$metadata = (value) => value.metadata;
export const Project$Project$7 = (value) => value.metadata;
export const Project$Project$created_at = (value) => value.created_at;
export const Project$Project$8 = (value) => value.created_at;
export const Project$Project$status = (value) => value.status;
export const Project$Project$9 = (value) => value.status;
export const Project$Project$version = (value) => value.version;
export const Project$Project$10 = (value) => value.version;

/**
 * Key for Salesforce in integrations dict.
 */
export const salesforce = "salesforce";

const month = 2_628_000;

export function toggle_owner(project, user_id) {
  let is_collaborator = $list.contains(project.collaborators, user_id);
  return $bool.guard(
    is_collaborator,
    project,
    () => {
      let is_owner = $list.contains(project.owners, user_id);
      return new Project(
        project.id,
        project.name,
        (() => {
          if (is_owner) {
            return $list.filter(
              project.owners,
              (u) => { return !isEqual(u, user_id); },
            );
          } else {
            return $list_.push(project.owners, user_id);
          }
        })(),
        project.org_id,
        project.deadline,
        project.client,
        project.collaborators,
        project.metadata,
        project.created_at,
        project.status,
        project.version,
      );
    },
  );
}

export function toggle_collaborator(project, user_id) {
  let is_owner = $list.contains(project.owners, user_id);
  return $bool.guard(
    is_owner,
    project,
    () => {
      let is_collaborator = $list.contains(project.collaborators, user_id);
      return new Project(
        project.id,
        project.name,
        project.owners,
        project.org_id,
        project.deadline,
        project.client,
        (() => {
          if (is_collaborator) {
            return $list.filter(
              project.collaborators,
              (u) => { return !isEqual(u, user_id); },
            );
          } else {
            return $list_.push(project.collaborators, user_id);
          }
        })(),
        project.metadata,
        project.created_at,
        project.status,
        project.version,
      );
    },
  );
}

function decode_integration() {
  return $decode.field(
    "opportunity_id",
    $decode.string,
    (opportunity_id) => {
      return $decode.success(new Salesforce(opportunity_id));
    },
  );
}

function metadata_decoder() {
  return $decrypt.optional_field(
    "attachments",
    $decode.list(
      $decode.field(
        "name",
        $decode.string,
        (name) => {
          return $decode.field(
            "content_type",
            $decode.string,
            (content_type) => {
              let $ = $mime_types.from_string(content_type);
              if ($ instanceof Ok) {
                let content_type$1 = $[0];
                return $decode.success(new Attachment(name, content_type$1));
              } else {
                return $decode.failure(
                  new Attachment("", new $mime_types.Csv()),
                  "Attachment",
                );
              }
            },
          );
        },
      ),
    ),
    (attachments) => {
      let attachments$1 = $option.unwrap(attachments, toList([]));
      return $decrypt.optional_field(
        "integrations",
        $decode.dict($decode.string, decode_integration()),
        (integrations) => {
          let integrations$1 = $option.unwrap(integrations, $dict.new$());
          return $decode.optional_field(
            "contain_narrative",
            false,
            $decode.bool,
            (contain_narrative) => {
              return $decrypt.optional_field(
                "outline",
                $output.outline_decoder(),
                (outline) => {
                  return $decode.success(
                    new Metadata(
                      contain_narrative,
                      attachments$1,
                      integrations$1,
                      outline,
                    ),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function version_decoder() {
  return $decode.then$(
    $decode.int,
    (content) => {
      if (content === 1) {
        return $decode.success(new V1());
      } else if (content === 2) {
        return $decode.success(new V2());
      } else {
        return $decode.failure(new V1(), "Version");
      }
    },
  );
}

function encode_integration(integration) {
  return $json.object(
    toList([["opportunity_id", $json.string(integration.opportunity_id)]]),
  );
}

export function encode_metadata(metadata) {
  return $json.object(
    toList([
      ["languages", $json.preprocessed_array(toList([]))],
      ["default_language", $json.null$()],
      [
        "attachments",
        $json.array(
          metadata.attachments,
          (attachment) => {
            let content_type = $mime_types.to_string(attachment.content_type);
            return $json.object(
              toList([
                ["name", $json.string(attachment.name)],
                ["content_type", $json.string(content_type)],
              ]),
            );
          },
        ),
      ],
      ["outline", $json.nullable(metadata.outline, $output.outline_to_json)],
      [
        "integrations",
        $json.dict(
          metadata.integrations,
          $function.identity,
          encode_integration,
        ),
      ],
    ]),
  );
}

export function version_to_int(version) {
  if (version instanceof V1) {
    return 1;
  } else {
    return 2;
  }
}

function encode_version(version) {
  let _pipe = version;
  let _pipe$1 = version_to_int(_pipe);
  return $json.int(_pipe$1);
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => {
          return $decode.field(
            "owners",
            (() => {
              let owner = $decode.map($user_id.decoder(), $list.wrap);
              let owners = $decode.list($user_id.decoder());
              return $decode.one_of(owners, toList([owner]));
            })(),
            (owners) => {
              return $decode.field(
                "org_id",
                $decode.string,
                (org_id) => {
                  return $decode.field(
                    "deadline",
                    $decrypt.timestamp(),
                    (deadline) => {
                      return $decode.field(
                        "client",
                        $decode.string,
                        (client) => {
                          return $decode.field(
                            "collaborators",
                            $decode.list($user_id.decoder()),
                            (collaborators) => {
                              return $decode.field(
                                "metadata",
                                $decrypt.json(metadata_decoder()),
                                (metadata) => {
                                  return $decode.field(
                                    "created_at",
                                    $decrypt.timestamp(),
                                    (created_at) => {
                                      return $decode.field(
                                        "status",
                                        $status.decoder(),
                                        (status) => {
                                          return $decrypt.optional_field(
                                            "version",
                                            version_decoder(),
                                            (version) => {
                                              let version$1 = $option.unwrap(
                                                version,
                                                new V1(),
                                              );
                                              return $decode.success(
                                                new Project(
                                                  id,
                                                  name,
                                                  owners,
                                                  org_id,
                                                  deadline,
                                                  client,
                                                  collaborators,
                                                  metadata,
                                                  created_at,
                                                  status,
                                                  version$1,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode(project) {
  return $json.object(
    toList([
      ["id", $json.string(project.id)],
      ["name", $json.string(project.name)],
      ["owner", $json.string("")],
      ["owners", $json.array(project.owners, $user_id.encode)],
      ["org_id", $json.string(project.org_id)],
      ["deadline", $timestamp_.encode(project.deadline)],
      ["client", $json.string(project.client)],
      ["collaborators", $json.array(project.collaborators, $user_id.encode)],
      ["metadata", encode_metadata(project.metadata)],
      ["created_at", $timestamp_.encode(project.created_at)],
      ["status", $status.encode(project.status)],
      ["version", encode_version(project.version)],
    ]),
  );
}

export function all_collaborators(project) {
  let _pipe = $list.append(project.owners, project.collaborators);
  return $list.unique(_pipe);
}

export function completed(project) {
  return !(project.status instanceof $status.InProgress);
}

export function name(project) {
  let $ = project.name;
  if ($ === "") {
    return "Untitled";
  } else {
    return $;
  }
}

export function set_name(project, name) {
  return new Project(
    project.id,
    name,
    project.owners,
    project.org_id,
    project.deadline,
    project.client,
    project.collaborators,
    project.metadata,
    project.created_at,
    project.status,
    project.version,
  );
}

export function set_client(project, client) {
  return new Project(
    project.id,
    project.name,
    project.owners,
    project.org_id,
    project.deadline,
    client,
    project.collaborators,
    project.metadata,
    project.created_at,
    project.status,
    project.version,
  );
}

export function set_deadline(project, deadline) {
  return new Project(
    project.id,
    project.name,
    project.owners,
    project.org_id,
    deadline,
    project.client,
    project.collaborators,
    project.metadata,
    project.created_at,
    project.status,
    project.version,
  );
}

export function salesforce_id(project) {
  let _pipe = project.metadata.integrations;
  let _pipe$1 = $dict.get(_pipe, salesforce);
  return $result.try$(
    _pipe$1,
    (i) => {
      let opportunity_id = i.opportunity_id;
      return new Ok(opportunity_id);
    },
  );
}

export function empty_project(org_id, owner_id) {
  return new Project(
    $uuid.new$(),
    "Untitled",
    toList([owner_id]),
    org_id,
    $timestamp.add($timestamp.system_time(), $duration.seconds(month)),
    "",
    toList([]),
    new Metadata(false, toList([]), $dict.new$(), new None()),
    $timestamp.system_time(),
    new $status.Draft(),
    new V2(),
  );
}

export function default_name(name) {
  if (name === "") {
    return "Untitled";
  } else {
    return name;
  }
}
